import { api } from "./api";

export interface Coupon {
  _id: string;
  code: string;
  description?: string;
  discountType: "percentage" | "fixed";
  discountValue: number;
  courseId?: string;
  maxUses?: number;
  usedCount: number;
  perUserLimit: number;
  allowedEmails?: string[];
  allowedUserIds?: string[];
  validFrom: string;
  validUntil: string;
  isActive: boolean;
  type: "general" | "whitelist";
}

export const couponApi = {
  applyCoupon: (code: string, courseId: string) => {
    return api.post<{ success: boolean; data: {
      originalPrice: number;
      discountAmount: number;
      finalPrice: number;
      currency: string;
      couponCode: string;
    } }>("/coupons/apply", { code, courseId });
  },

  getAllCoupons: () => {
    return api.get<{ success: boolean; data: Coupon[] }>("/coupons");
  },

  getCoupon: (id: string) => {
    return api.get<{ success: boolean; data: Coupon }>(`/coupons/${id}`);
  },

  createCoupon: (data: Partial<Coupon>) => {
    return api.post<{ success: boolean; data: Coupon }>("/coupons", data);
  },

  updateCoupon: (id: string, data: Partial<Coupon>) => {
    return api.put<{ success: boolean; data: Coupon }>(`/coupons/${id}`, data);
  },

  deleteCoupon: (id: string) => {
    return api.delete<{ success: boolean; message: string }>(`/coupons/${id}`);
  },

  validateCoupon: (code: string, courseId: string) => {
    return api.post<{ success: boolean; data: { valid: boolean; message?: string } }>("/coupons/validate", { code, courseId });
  },
};